import { QueryClient } from "@tanstack/react-query";

// Reasonable defaults for a dashboard: cache for 30s so quick
// navigation feels instant, but don't hold stale rollup numbers
// forever.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
